module.exports = __webpack_public_path__ + "img/158.fd4e017a.jpg";